import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Quote from "../components/Quote";
import DishOfTheDay from "../components/DishOfTheDay";
import FacebookInvite from "../components/FacebookInvite";
import OpeningHours from "../components/OpeningHours";
import OrderWithDelivery from "../components/OrderWithDelivery";
import Catering from "../components/Catering";

function Home({ dishSectionRef }) {

    const location = useLocation();

    useEffect(() => {
        if (location.state?.scrollToDish && dishSectionRef.current) {
            dishSectionRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [location, dishSectionRef]);

    return (
        <main>
            <DishOfTheDay dishSectionRef={ dishSectionRef } />
            <FacebookInvite />
            <OpeningHours />
            <OrderWithDelivery />
            <Catering />
        </main>
    )
}

export default Home;